import { useState, useEffect } from "react";

const Loader = () => {
  const [loading] = useState(true);

  useEffect(() => {
    // Add or remove the blur class from the body based on loading state
    if (loading) {
      document.body.classList.add("blurred");
    } else {
      document.body.classList.remove("blurred");
    }

    // Cleanup function to remove the blur class when the component unmounts
    return () => {
      document.body.classList.remove("blurred");
    };
  }, [loading]);

  return (
    <>
      {loading && (
        <div className="position-fixed w-100 h-100 start-0 top-0 z-3 d-flex align-items-center justify-content-center">
          <div className="pre_loader z-3"></div>
          <div className="loader-overlay z-2"></div>
        </div>
      )}
    </>
  );
};

export default Loader;
